import "./../../bindings/bao-toolbar2";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function Device4AssignmentTab(tabPage, device4ViewModel) {
    var self = this;
    self.TabPage = tabPage;
    self.Device4ViewModel = device4ViewModel;
    self.Selection = ko.observableArray();
    self.SelectedDevice3Ids = ko.observableArray();
    self.Sorting = ko.observableArray();
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.Models = ko.observableArray();
    self.NewArray = ko.observableArray([]);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize.subscribe(function () {
        if (self.PageIndex() != 0) {
            self.PageIndex(0);
        }
        else {
            self.Refresh();
        }
    });
    self.Sorting.subscribe(function () {
        self.Refresh();
    });
    self.Selection.subscribe(function () {
        self.toggleButtons();
    });
    self.SelectedDevice3Ids.subscribe(function (selectedDevice3Ids) {
        if (selectedDevice3Ids != null && selectedDevice3Ids.length > 0) {
            var device3Ids = [];
            ko.utils.arrayForEach(selectedDevice3Ids, function (item: any) {
                device3Ids.push(ko.unwrap(item.Device3Id));
            });
            self.addDevice3ToSession(device3Ids);
        }
    });
    self.toolbarButtonClicked = function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey().substr(('Device4Device3Assignment').length);
            switch (functionString) {
                case 'Add':
                    self.addDevice3();
                    break;
                case 'Remove':
                    self.removeDevice3();
                    break;
                default:
                    break;
            }
        }
    };
    self.toolbarLoaded = function () {
        self.toggleButtons();
    };
    self.addDevice3 = function (device3) {
        this.openDevice3Searcher();
    };
    self.openDevice3Searcher = function () { };
}
;
Device4AssignmentTab.prototype.Refresh = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("MasterData/Device4/GetAssignedDevice3Ids", JSON.stringify({
        sessionTabId: self.Device4ViewModel.SessionTabId(),
        device4Id: self.Device4ViewModel.Device4Id(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting()
    }), function (searchResult) {
        self.SelectedDevice3Ids([]);
        self.NewArray([]);
        self.TotalRows(0);
        self.Models([]);
        if (searchResult != null && searchResult.Models != null) {
            self.Models(searchResult.Models);
            self.TotalRows(searchResult.TotalRows);
            self.toggleButtons();
        }
    }).always(function () {
        self.TabPage.IsLoading(false);
    });
};
Device4AssignmentTab.prototype.toggleButtons = function () {
    if (this.enableButton != undefined) {
        var selection = this.Selection.peek();
        this.enableButton('Device4Device3AssignmentRemove', selection && (selection.length > 0));
    }
};
Device4AssignmentTab.prototype.removeDevice3 = function (a, b, c) {
    var self = this;
    self.TabPage.IsLoading(true);
    var device3Ids = [];
    ko.utils.arrayForEach(self.Selection(), function (item: any) {
        device3Ids.push(ko.unwrap(item.Device3Id));
    });
    return Bao.post("MasterData/Device4/DeleteDevice3", JSON.stringify({
        sessionTabId: self.Device4ViewModel.SessionTabId(),
        device4Id: self.Device4ViewModel.Device4Id(),
        device3Ids: device3Ids
    }), function () {
        self.Device4ViewModel.TabPage.DirtyFlag(true);
        self.Refresh();
    });
};
Device4AssignmentTab.prototype.addDevice3ToSession = function (device3Ids) {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("MasterData/Device4/AddDevice3", JSON.stringify({
        sessionTabId: self.Device4ViewModel.SessionTabId(),
        device4Id: self.Device4ViewModel.Device4Id(),
        device3Ids: device3Ids
    }), function () {
        self.Device4ViewModel.TabPage.DirtyFlag(true);
        self.Refresh();
    });
};
export default Device4AssignmentTab;